import { render, staticRenderFns } from "./DuplicateOrderModal.vue?vue&type=template&id=25acbf22"
import script from "./DuplicateOrderModal.vue?vue&type=script&lang=js"
export * from "./DuplicateOrderModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateOrderModal.vue?vue&type=style&index=0&id=25acbf22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports